import * as React from 'react';
import { IRootState } from 'store/modules';
import { connect, DispatchProp } from 'react-redux';
import { SubscriptionInfoComponent } from 'components/presentational/views/AccountSettings/SubscriptionInfo'
import { Models } from 'fluent-forever-shared-types';
import * as App from 'application';
import { ChargeBee } from 'api';

export interface ISubscriptionInfoProps extends DispatchProp {
    fetchData(): Promise<Models.IAccountSettings>;
    openManagement(subscriptionId);
}

interface ISubscriptionInfoState {
    data: Models.IAccountSettings;
}

const mapStateToProps = (state: IRootState) => ({
    // Get all user's subscriptions
    // userSubscriptions: App.User.getSubscriptions(state)
});

const mapDispatchToProps = (dispatch) => ({
    fetchData: () => App.Settings.fetchAccountSettings(dispatch),
    openManagement: (subscriptionId) => App.Subscriptions.openManagementPortal(subscriptionId, dispatch),
})

const defaultState: ISubscriptionInfoState = { data: { subscriptionId: '', planId: '', planName: '', discounts: [] } }

//** Container/UI logic for Redeeming Code */
class SubscriptionInfoContainer extends React.Component<ISubscriptionInfoProps, ISubscriptionInfoState> {
    constructor(props) {
        super(props);
        this.state = defaultState;
    }

    componentDidMount() {
        this.props.fetchData().then(result => {
            if (result) {
                this.setState({ data: result })
            }
        })
    }

    render() {
        const { planId, planName, discounts, expiry, subscriptionId } = this.state.data;
        const discount = discounts ? discounts.join(', ') : 'N/A';
        const expires = expiry || 'N/A';

        return <SubscriptionInfoComponent
            subscriptionId={subscriptionId}
            planId={planId}
            discounts={discount}
            planName={planName}
            expiry={expires}
            // openPlanDetails={(subId) => ChargeBee.openAccountDetails()}
            openBillingAddress={ChargeBee.openAddresses}
            openPaymentSources={ChargeBee.openPaymentSources}
        />
    }
}

export const SubscriptionInfo = connect(mapStateToProps, mapDispatchToProps)(SubscriptionInfoContainer);


// WEBPACK FOOTER //
// ./src/components/containers/SubscriptionInfo/index.tsx